import type { ReactNode } from 'react';

import { Box } from 'components/Box/Box';

import { List } from './BulletList.styled';

type Props = {
  items: {
    key: string | number;
    value: ReactNode;
  }[];
  columns?: 1 | 2;
  itemMargin?: number;
  mt?: number;
  qaId?: string;
};

export function BulletList({
  items,
  columns = 1,
  itemMargin = 0,
  mt,
  qaId,
}: Props) {
  return (
    <Box
      component={List}
      classes={['flex']}
      mb={`-${itemMargin}px`}
      mt={mt}
      qaId={qaId}
    >
      {items.map(
        ({ key, value }) =>
          value && (
            <Box
              component="li"
              key={key}
              width={[1, 1, 1, 1 / columns]}
              mb={`${itemMargin}px`}
            >
              {value}
            </Box>
          ),
      )}
    </Box>
  );
}
